(function($) {
  $('.index-banner-slider').slick({
    fade: false,
    autoplay: true,
    autoplaySpeed: 6000,
    dots: true,
    arrows: true,
    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="ic ic-angle-left"></i></button>',
    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="ic ic-angle-right"></i></button>',
    // pauseOnHover: false,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          arrows: false,
        }
      },
    ],
  });
  $('.index-honors-slider').slick({
    dots: false,
    arrows: true,
    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="ic ic-angle-left"></i></button>',
    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="ic ic-angle-right"></i></button>',
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ],
  });
})($);
